'use strict';

import AxiosURLSearchParams from '../../../helpers/AxiosURLSearchParams.js';
export default typeof URLSearchParams !== 'undefined' ? URLSearchParams : AxiosURLSearchParams;



//////////////////
// WEBPACK FOOTER
// ./~/_axios@1.4.0@axios/lib/platform/browser/classes/URLSearchParams.js
// module id = 146
// module chunks = 1